"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INITIATIVES_STATUS = void 0;
exports.INITIATIVES_STATUS = {
    FINISHED: 'Finished',
    IN_PROGRESS: 'In Progress',
    NEW: 'New',
    READY: 'Ready',
    TESTING: 'Testing'
};
//# sourceMappingURL=INITIATIVES_STATUS.js.map